var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useLucidSdk } from '#context';
import { SsoIntegrationKeyFactory, WorkspaceLoginStatusKeyFactory, } from '../../query-key-factories';
export const useWorkspaceSsoLogin = ({ onError, onSuccess, } = {}) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ accessToken, workspaceId, }) => lucidSdk.workspaceClient(workspaceId).ssoLogin(accessToken),
        onSuccess: async (_data, { workspaceId }) => {
            try {
                await Promise.all([
                    queryClient.refetchQueries({
                        exact: true,
                        queryKey: WorkspaceLoginStatusKeyFactory.byWorkspace(workspaceId),
                    }),
                    queryClient.refetchQueries({
                        exact: true,
                        queryKey: SsoIntegrationKeyFactory.byWorkspaceId(workspaceId),
                    }),
                ]);
            }
            finally {
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            }
        },
        onError: (e) => {
            if (typeof onError === 'function') {
                onError(e);
            }
        },
    });
    return mutation;
};
_react_refresh_temp_1(useWorkspaceSsoLogin, "s074ag8lSG2K0z8InO7Yl75Raxc=", false, () => [useLucidSdk, useQueryClient, useMutation]);
